import React from 'react';
import { get } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Summary = ({ expansionPanelSummary, title, isCollapsed, disabled, style, handleClick }) => {
  const children = (
    <>
      <span className="title">{title}</span>
      {!disabled ? <FontAwesomeIcon icon={faPencilAlt} size="sm" /> : <></>}
    </>
  );

  const className = cn('header-ca425ffc-c58d-4da6-a4e5-9bc8c568e36a', { disabled: disabled });

  return (
    <div style={{ background: get(style, 'panel.backgroundColor') }} className="expansionPanelSummary">
      {disabled ? (
        <div role="presentation" className={className}>
          {children}
        </div>
      ) : (
        <div role="presentation" onClick={handleClick} className={className}>
          {children}
        </div>
      )}
      <div style={{ display: isCollapsed ? 'block' : 'none' }} className="body">
        {expansionPanelSummary}
      </div>
    </div>
  );
};

Summary.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  expansionPanelSummary: PropTypes.any,
  title: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.any,
  handleClick: PropTypes.func.isRequired,
};
Summary.defaultProps = {
  expansionPanelSummary: <div />,
  disabled: false,
  style: {},
};

export default Summary;
